import { ITypedReduxAction } from '../../types/redux/actionType';
import { TThunkAction } from '../../types/redux/thunk';
import { getSpecialProjectsBlocks } from '../../services/specialPromosBlocks';
import { ISpecialPromosBlocks } from '../../types/specialPromosBlocks';
import { mergePikPlusDataToInitialState } from '../../mappers/mergePikPlusDataToInitialState';

export enum ESpecialPromosBlocksTypes {
  ESpecialPromosBlocksRefresh = 'SPECIAL_PROMOS_BLOCKS/REFRESH',
}

export type TSpecialPromosBlocksRefresh = ITypedReduxAction<
  ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh,
  ISpecialPromosBlocks
>;

export function specialPromosBlocksRefresh(locationId: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState, { config, httpApi, logger }) => {
    try {
      const state = getState();
      const [banks, residentialComplexesDto, phone, mortgageBanner] = await getSpecialProjectsBlocks(
        { logger, httpApi, config },
        locationId,
      );

      mergePikPlusDataToInitialState(state, residentialComplexesDto);

      dispatch({
        type: ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh,
        payload: {
          banks,
          phone,
          mortgageBanner,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
}
